import { ReactNode } from 'react';

import logoTextBlack from '@/assets/logo_text_black.png';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

export interface PublicPageShellProps {
  title: ReactNode;
  description?: ReactNode;
  children: ReactNode;
}

/** Centered logo + card used by the login and other unauthenticated pages. */
export function PublicPageShell({
  title,
  description,
  children,
}: PublicPageShellProps) {
  return (
    <div className="flex min-h-screen items-start justify-center px-4 pt-[10vh]">
      <div className="w-full max-w-sm space-y-6">
        <div className="flex justify-center">
          <img
            src={logoTextBlack}
            alt="Certhon"
            className="h-12 w-auto dark:invert"
          />
        </div>
        <Card className="border-border/40 shadow-lg">
          <CardHeader className="space-y-1 text-center">
            <CardTitle className="text-2xl font-semibold tracking-tight">
              {title}
            </CardTitle>
            {description && (
              <CardDescription className="text-muted-foreground">
                {description}
              </CardDescription>
            )}
          </CardHeader>
          <CardContent>{children}</CardContent>
        </Card>
      </div>
    </div>
  );
}
